import React from 'react';

export default function ProductCard({ id, title, tagline, description, list, image, color, platforms, status, url, onNavigate }) {
  const isLive = status === 'live';
  const initial = title ? title.replace('Suko ', '')[0] : '?';

  return (
    <div className="product-card">

      <div className="product-card-header">
        <div className="product-card-icon" style={{ backgroundColor: color }}>
          {image ? (
            <img src={image} alt={title} />
          ) : (
            <span className="product-card-icon-placeholder">{initial}</span>
          )}
        </div>

        <div className="product-card-meta">
          <h2 className="product-card-title">{title}</h2>
          <p className="product-card-tagline">{tagline}</p>
        </div>

        <div className="product-card-platforms">
          {platforms && platforms.map((p, i) => (
            <span key={i} className="product-platform-badge">{p}</span>
          ))}
        </div>
      </div>

      <div className="product-card-body">
        <p className="product-card-description">{description}</p>

        <hr className="product-card-divider" />

        <p className="product-card-features-label">Funcionalidades</p>
        <ul className="product-card-features">
          {list && list.slice(0, 5).map((item, i) => (
            <li key={i} className="product-card-feature">{item}</li>
          ))}
        </ul>
      </div>

      <div className="product-card-footer">
        <span className={`product-status-badge ${isLive ? 'live' : 'coming-soon'}`}>
          {isLive ? 'Disponible' : 'Próximamente'}
        </span>

        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          {onNavigate && (
            <button
              onClick={() => onNavigate(`/products/${id}`)}
              className="product-card-cta"
              style={{ background: 'none', border: '1px solid rgba(15,17,56,0.15)', color: '#0F1138', boxShadow: 'none', cursor: 'pointer' }}
            >
              Saber más
            </button>
          )}

        </div>
      </div>
      <div>
        {isLive ? (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="product-card-cta"
          >
            Abrir app
            <span className="product-cta-arrow">↗</span>
          </a>
        ):null}
      </div>

    </div>
  );
}
